
export enum MessagingSystem {
    SprayAndWait,
    DensityAwareSprayAndWait
}